import { Typography, Box, Divider } from "@mui/material";
import { t } from "@lingui/macro";
import { WfIconContentArrowRightRegular } from "@WahooFitness/redesignr";

interface HistoricalFitnessProfileThrCadProps {
  thr?: number;
  cad?: number;
  previousThr?: number;
  previousCad?: number;
}

const HistoricalFitnessProfileThrCad = ({
  thr,
  cad,
  previousThr,
  previousCad,
}: HistoricalFitnessProfileThrCadProps) => {
  const ThrCadItems = [
    {
      id: "thr",
      name: t`Threshold Heart Rate`,
      value: thr,
      previousValue: previousThr,
      unit: t`BPM`,
    },
    {
      id: "map",
      name: t`Preferred Cadence`,
      value: cad,
      previousValue: previousCad,
      unit: t`RPM`,
    },
  ];

  if (!ThrCadItems.some((item) => item.value)) {
    return null;
  }

  return (
    <>
      <Divider />
      <Box display="flex" flexDirection="column" gap={2}>
        {ThrCadItems.map((item) =>
          item.value ? (
            <Box
              key={item.id}
              display="flex"
              alignItems="center"
              width="100%"
              justifyContent="space-between"
            >
              <Typography variant="prose-sm-medium">{item.name}</Typography>

              <Box display="flex" alignItems="center" gap={0.5}>
                {item.previousValue && item.previousValue !== item.value && (
                  <>
                    <Typography variant="prose-sm-medium">
                      {item.previousValue} {item.unit}
                    </Typography>
                    <WfIconContentArrowRightRegular
                      fontSize="small"
                      color={item.value > item.previousValue ? "success" : "error"}
                    />
                  </>
                )}
                <Typography variant="prose-sm-medium">
                  {item.value} {item.unit}
                </Typography>
              </Box>
            </Box>
          ) : null
        )}
      </Box>
    </>
  );
};

export default HistoricalFitnessProfileThrCad;
